<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :isHaveExport="false"
      :isHavePagination="false"
      :isShow="false"
      @toAdd="openCreateDialog"
    >
      <template v-slot:table>
        <el-table :data="list" style="width: 100%" :border="true">
          <el-table-column prop="name" label="任务名称" min-width="180" />
          <el-table-column prop="description" label="任务描述" min-width="200" />

          <el-table-column label="调度任务" min-width="180" align="center">
            <template v-slot="scope">
              <span v-if="scope.row.schedulers">
                {{ scope.row.schedulers.name }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="hasSystemTask"
            prop="channel_name"
            label="渠道"
            min-width="140"
            align="center"
          >
            <template v-slot="scope">
              <span v-if="scope.row.is_system_task">
                {{ scope.row.channel_name || scope.row.channel_id || "--" }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="hasSystemTask"
            prop="policy_count"
            label="策略数"
            width="90"
            align="center"
          >
            <template v-slot="scope">
              <span v-if="scope.row.is_system_task">
                {{ scope.row.policy_count || 0 }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="execution_time"
            label="执行时间"
            align="center"
            width="160"
          >
            <template v-slot="scope">
              {{ formatTime(scope.row.execution_time) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="next_run_at"
            label="下次执行时间"
            align="center"
            width="170"
          >
            <template v-slot="scope">
              {{ formatTime(scope.row.next_run_at) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="recurrence_frequency"
            label="重复频率"
            align="center"
            width="110"
          >
            <template v-slot="scope">
              {{ formatFrequency(scope.row.recurrence_frequency) }}
            </template>
          </el-table-column>

          <el-table-column prop="status" label="任务状态" align="center" width="110">
            <template v-slot="scope">
              <el-tag :type="statusTagType(scope.row.status)">
                {{ getStatus(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="schedule_type"
            label="调度类型"
            align="center"
            width="110"
          >
            <template v-slot="scope">
              {{ formatScheduleType(scope.row.schedule_type) }}
            </template>
          </el-table-column>

          <el-table-column
            v-if="hasSystemTask"
            prop="last_run_status"
            label="最近运行"
            align="center"
            width="120"
          >
            <template v-slot="scope">
              <el-tag
                v-if="scope.row.is_system_task && scope.row.last_run_status"
                :type="getTaskRunStatusType(scope.row.last_run_status)"
              >
                {{ getTaskRunStatusLabel(scope.row.last_run_status) }}
              </el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="hasSystemTask"
            prop="last_run_at"
            label="最近运行时间"
            align="center"
            width="170"
          >
            <template v-slot="scope">
              <span v-if="scope.row.is_system_task">
                {{ formatTime(scope.row.last_run_at) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="recurrence_days"
            label="重复星期"
            align="center"
            width="120"
          >
            <template v-slot="scope">
              <span
                v-if="
                  scope.row.schedule_type === 'recurring' &&
                  scope.row.recurrence_frequency === 'weekly'
                "
              >
                {{ scope.row.recurrence_days || "--" }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="operation"
            align="center"
            label="操作"
            width="260"
            fixed="right"
          >
            <template v-slot="scope">
              <el-tooltip
                v-if="scope.row.is_system_task"
                content="系统生成，只允许修改状态和调度"
                placement="top"
              >
                <el-button size="mini" type="primary" @click="editTask(scope.row)">
                  编辑
                </el-button>
              </el-tooltip>
              <el-button
                v-else
                size="mini"
                type="primary"
                @click="editTask(scope.row)"
              >
                编辑
              </el-button>

              <el-button
                v-if="scope.row.is_system_task"
                size="mini"
                type="info"
                @click="openRunLogDrawer(scope.row)"
              >
                运行日志
              </el-button>

              <el-tooltip
                v-if="scope.row.is_system_task"
                content="系统生成，不支持删除"
                placement="top"
              >
                <span class="task-action-wrapper">
                  <el-button size="mini" type="danger" disabled>
                    删除
                  </el-button>
                </span>
              </el-tooltip>
              <el-button
                v-else
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="deleteTask(scope.row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      :title="isEditing ? '编辑任务' : '新增任务'"
      :visible.sync="dialogVisible"
      width="640px"
      @closed="resetDialog"
    >
      <el-form ref="form" :model="taskForm" size="small" :rules="rules" label-width="120px">
        <el-form-item label="任务名称" prop="name">
          <el-input
            v-model="taskForm.name"
            :disabled="isSystemTaskEditing"
            placeholder="请输入任务名称"
          />
        </el-form-item>

        <el-form-item label="任务描述" prop="description">
          <el-input
            v-model="taskForm.description"
            type="textarea"
            :disabled="isSystemTaskEditing"
            placeholder="请输入任务描述"
          />
        </el-form-item>

        <el-form-item label="任务状态" prop="status">
          <el-select v-model="taskForm.status" placeholder="请选择任务状态" style="width: 100%">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="调度类型" prop="schedule_type">
          <el-select
            v-model="taskForm.schedule_type"
            :disabled="isSystemTaskEditing"
            placeholder="请选择调度类型"
            style="width: 100%"
            @change="handleScheduleTypeChange"
          >
            <el-option
              v-for="item in scheduleTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="执行时间" prop="execution_time">
          <el-date-picker
            v-model="taskForm.execution_time"
            type="datetime"
            placeholder="请选择执行时间"
            value-format="timestamp"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item
          v-if="taskForm.schedule_type === 'recurring'"
          label="重复频率"
          prop="recurrence_frequency"
        >
          <el-select
            v-model="taskForm.recurrence_frequency"
            placeholder="请选择重复频率"
            style="width: 100%"
          >
            <el-option
              v-for="item in frequencyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="
            taskForm.schedule_type === 'recurring' &&
            taskForm.recurrence_frequency === 'weekly'
          "
          label="重复星期"
          prop="recurrence_days"
        >
          <el-select
            v-model="taskForm.recurrence_days"
            multiple
            placeholder="请选择星期"
            style="width: 100%"
          >
            <el-option
              v-for="item in dayOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="调度任务" prop="rule_id">
          <el-select
            v-model="taskForm.rule_id"
            :disabled="isSystemTaskEditing"
            placeholder="请选择调度任务"
            style="width: 100%"
          >
            <el-option
              v-for="item in schedulerSelectOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="isSystemTaskEditing" label="处理模块">
          <el-input
            :value="
              taskForm.schedulers && taskForm.schedulers.handler_module
                ? taskForm.schedulers.handler_module
                : '--'
            "
            disabled
          />
        </el-form-item>

        <el-form-item v-if="isSystemTaskEditing" label="渠道">
          <el-input
            :value="taskForm.channel_name || taskForm.channel_id || '--'"
            disabled
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTask">保存</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="运行日志"
      :visible.sync="runLogDrawerVisible"
      size="520px"
      direction="rtl"
    >
      <div class="run-log-drawer" v-loading="runLogLoading">
        <div class="run-log-drawer__meta" v-if="currentRunLogTask">
          <div class="run-log-drawer__title">
            {{ currentRunLogTask.name || "--" }}
          </div>
          <div class="run-log-drawer__sub">
            渠道：{{ currentRunLogTask.channel_name || currentRunLogTask.channel_id || "--" }}
          </div>
        </div>

        <el-timeline v-if="runLogList.length">
          <el-timeline-item
            v-for="item in runLogList"
            :key="item.id"
            :timestamp="formatTime(item.finished_at || item.started_at || item.created_time)"
            placement="top"
          >
            <el-card shadow="never" class="run-log-card">
              <div class="run-log-card__head">
                <el-tag :type="getTaskRunStatusType(item.status)">
                  {{ getTaskRunStatusLabel(item.status) }}
                </el-tag>
                <span class="run-log-card__reason" v-if="item.skip_reason">
                  {{ item.skip_reason }}
                </span>
              </div>
              <div class="run-log-card__line">
                命中：{{ item.matched_user_count || 0 }}，成功：{{
                  item.processed_user_count || 0
                }}，失败：{{ item.failed_user_count || 0 }}
              </div>
              <div class="run-log-card__line">
                窗口：{{ formatTime(item.window_start_time) }} - {{ formatTime(item.window_end_time) }}
              </div>
              <div class="run-log-card__line">
                说明：{{ item.message || "暂无说明" }}
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>

        <el-empty v-else description="暂无运行日志" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getTaskRunStatusLabel,
  getTaskRunStatusType,
  isSystemTask,
} from "@/utils/riskTask";

const defaultTaskForm = () => ({
  id: "",
  name: "",
  description: "",
  status: "pending",
  priority: "medium",
  schedule_type: "once",
  execution_time: null,
  recurrence_frequency: null,
  recurrence_interval: 1,
  recurrence_days: [],
  rule_id: null,
  channel_id: "",
  channel_name: "",
  schedulers: null,
  is_system_task: false,
});

export default {
  data() {
    return {
      dialogVisible: false,
      isEditing: false,
      runLogDrawerVisible: false,
      runLogLoading: false,
      currentRunLogTask: null,
      runLogList: [],
      taskForm: defaultTaskForm(),
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择任务状态", trigger: "change" }],
        schedule_type: [
          { required: true, message: "请选择调度类型", trigger: "change" },
        ],
        execution_time: [
          { required: true, message: "请选择执行时间", trigger: "change" },
        ],
        rule_id: [
          { required: true, message: "请选择调度任务", trigger: "change" },
        ],
      },
      list: [],
      statusOptions: [
        { value: "pending", label: "待处理", disabled: false },
        { value: "running", label: "运行中", disabled: true },
        { value: "completed", label: "已完成", disabled: true },
        { value: "failed", label: "失败", disabled: true },
        { value: "paused", label: "暂停", disabled: false },
      ],
      scheduleTypeOptions: [
        { value: "once", label: "单次" },
        { value: "recurring", label: "重复执行" },
      ],
      frequencyOptions: [
        { value: "daily", label: "每天" },
        { value: "weekly", label: "每周" },
        { value: "monthly", label: "每月" },
      ],
      dayOptions: [
        { value: "1", label: "星期一" },
        { value: "2", label: "星期二" },
        { value: "3", label: "星期三" },
        { value: "4", label: "星期四" },
        { value: "5", label: "星期五" },
        { value: "6", label: "星期六" },
        { value: "7", label: "星期日" },
      ],
      schedulersOptions: [],
    };
  },
  computed: {
    hasSystemTask() {
      return this.list.some((item) => isSystemTask(item));
    },
    isSystemTaskEditing() {
      return this.isEditing && isSystemTask(this.taskForm);
    },
    schedulerSelectOptions() {
      return this.schedulersOptions.filter((item) => !item.is_system_scheduler);
    },
  },
  methods: {
    getTaskRunStatusLabel,
    getTaskRunStatusType,
    formatTime(value) {
      return value ? this.$fnc.getTimeFormat(value, "ymdhms") : "--";
    },
    getStatus(status) {
      const target = this.statusOptions.find((item) => item.value === status);
      return target ? target.label : status || "--";
    },
    statusTagType(status) {
      const typeMap = {
        pending: "warning",
        running: "primary",
        completed: "success",
        failed: "danger",
        paused: "info",
      };
      return typeMap[status] || "info";
    },
    formatScheduleType(type) {
      const typeMap = {
        once: "单次",
        recurring: "重复执行",
      };
      return typeMap[type] || type || "--";
    },
    formatFrequency(frequency) {
      const frequencyMap = {
        daily: "每天",
        weekly: "每周",
        monthly: "每月",
      };
      return frequencyMap[frequency] || frequency || "--";
    },
    async getSchedulersOptions() {
      const data = await this.$api.getSchedulers.getSchedulersOptions();
      this.schedulersOptions = Array.isArray(data.data) ? data.data : [];
    },
    handleScheduleTypeChange(value) {
      if (value === "once") {
        this.taskForm.recurrence_frequency = null;
        this.taskForm.recurrence_interval = 1;
        this.taskForm.recurrence_days = [];
      }
    },
    async getTaskList() {
      try {
        const data = await this.$api.getTasks.getTasksList();
        this.list = Array.isArray(data.data) ? data.data : [];
      } catch (error) {
        console.error("获取任务列表失败:", error);
      }
    },
    openCreateDialog() {
      this.isEditing = false;
      this.taskForm = defaultTaskForm();
      this.dialogVisible = true;
    },
    resetDialog() {
      this.taskForm = defaultTaskForm();
      this.isEditing = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    async saveTask() {
      try {
        const params = {
          ...this.taskForm,
          recurrence_days: Array.isArray(this.taskForm.recurrence_days)
            ? this.taskForm.recurrence_days.join(",")
            : this.taskForm.recurrence_days,
        };
        this.$refs.form.validate(async (valid) => {
          if (!valid) {
            return;
          }
          if (this.isEditing) {
            await this.$api.getTasks.saveTasks(params);
            this.$message.success("任务更新成功");
          } else {
            await this.$api.getTasks.addTasks(params);
            this.$message.success("任务新增成功");
          }
          this.dialogVisible = false;
          this.getTaskList();
        });
      } catch (error) {
        console.error("保存任务失败:", error);
        this.$message.error("保存任务失败");
      }
    },
    async editTask(task) {
      this.isEditing = true;
      const data = await this.$api.getTasks.getTasksInfo({ id: task.id });
      const detail = data.data || {};
      this.taskForm = {
        ...defaultTaskForm(),
        ...task,
        ...detail,
        execution_time: detail.execution_time ? detail.execution_time * 1000 : null,
        recurrence_days: detail.recurrence_days
          ? String(detail.recurrence_days).split(",").filter(Boolean)
          : [],
        schedulers: detail.schedulers || task.schedulers || null,
        is_system_task: Boolean(detail.is_system_task || task.is_system_task),
      };
      this.dialogVisible = true;
    },
    deleteTask(id) {
      this.$confirm("确定要删除这个任务吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.getTasks.delTasks({ id });
          this.$message.success("删除成功");
          this.getTaskList();
        })
        .catch(() => {});
    },
    async openRunLogDrawer(task) {
      this.currentRunLogTask = task;
      this.runLogDrawerVisible = true;
      this.runLogLoading = true;
      try {
        const data = await this.$api.getTasks.getTaskRunLogList({
          task_id: task.id,
          limit: 20,
        });
        this.runLogList = Array.isArray(data.data) ? data.data : [];
      } finally {
        this.runLogLoading = false;
      }
    },
  },
  async created() {
    await this.getSchedulersOptions();
    this.getTaskList();
  },
};
</script>

<style lang="less" scoped>
.el-table {
  margin-top: 20px;
}

.el-dialog {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.el-select,
.el-input {
  width: 100%;
}

.task-action-wrapper {
  display: inline-block;
}

.run-log-drawer {
  padding: 0 16px 16px;
}

.run-log-drawer__meta {
  margin-bottom: 16px;
}

.run-log-drawer__title {
  color: #203864;
  font-size: 16px;
  font-weight: 600;
}

.run-log-drawer__sub {
  margin-top: 6px;
  color: #7a8da9;
  font-size: 13px;
}

.run-log-card {
  border-radius: 14px;
}

.run-log-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.run-log-card__reason {
  color: #a46c18;
  font-size: 12px;
}

.run-log-card__line {
  margin-top: 10px;
  color: #516b96;
  line-height: 1.6;
}
</style>
